import { validateEmail, validatePhoneNumber } from "../../helper";

export const validateSignup = (payload) => {
  const { given_name, phone_number, email } = payload;
  if (!given_name) {
    return { error: "Given name is mandatory" };
  } else if (given_name.length <= 4) {
    return { error: "Minimum 5 characters are required for given name" };
  } else if (!phone_number) {
    return { error: "Phone number is mandatory" };
  } else if (!validatePhoneNumber(phone_number)) {
    return { error: "Phone number is invalid" };
  } else if (!email) {
    return { error: "Email is mandatory" };
  } else if (!validateEmail(email)) {
    return { error: "Email is invalid" };
  } else {
    return true;
  }
};
